export default __webpack_public_path__ + "static/media/user_profile.4e7396f3.jpg";